import React, { useEffect, useState } from "react";
import Logo from "../images/logo.png";
import SideNav from "../components/SideNav";
import Footer from "../components/Footer";
import ToggleNav from "../components/ToggleNav";
import ImgProfile from "../images/img-profile.svg";
import fullscreeen from "../images/fullscreen.png";
import zoomin from "../images/zoomin.png";
import zoomout from "../images/zoomout.png";
import iconCalendar from "../images/iconCalendar.svg";
import IconExcel from "../images/IconExcel.svg";
import IconPPT from "../images/IconPPT.svg";
import IconAI from "../images/IconAI.svg";
import IconFigma from "../images/IconFigma.svg";
import IconFolder from "../images/folder.svg";
import ReactPlayer from "react-player";
import Avatar1 from "../images/Avatar1.svg";
import Avatar2 from "../images/Avatar2.svg";
import Avatar3 from "../images/Avatar3.svg";
import Avatar4 from "../images/Avatar4.svg";
import deleteIcon3 from "../images/mediaPlayer/trash1.svg";
import DeletePopup from "../images/deletePopup.svg";
import ImgStolityApp from "../images/img-stolity-app.png";
import { ReactComponent as PasswordShow } from "../images/icon-eye.svg";
import { ReactComponent as PasswordHide } from "../images/icon-eye-hide.svg";
import axios from "axios";
import { Modal as RsuiteModal } from "rsuite";
import { useNavigate } from "react-router-dom";
import loaderGif from "../images/Loaders/Animation4.gif";

import { Progress, Modal } from "antd";

import { ChakraProvider, Stack, useToast } from "@chakra-ui/react";

import {
  Tooltip,
  Whisper,
  SelectPicker,
  Dropdown,
  Popover,
  Placeholder,
  Button,
} from "rsuite";
import { Modal as Bigmodal } from "rsuite";
import { useSelector } from "react-redux";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const months = [
  { name: "1 Month", code: "01" },
  { name: "2 Month", code: "02" },
  { name: "3 Month", code: "03" },
  { name: "4 Month", code: "04" },
  { name: "5 Month", code: "05" },
  { name: "6 Month", code: "06" },
  { name: "7 Month", code: "07" },
  { name: "8 Month", code: "08" },
  { name: "9 Month", code: "09" },
  { name: "10 Month", code: "10" },
  { name: "11 Month", code: "11" },
  { name: "12 Month", code: "12" },
];

const UserProfile = () => {
  const apiUrl = process.env.REACT_APP_API_ENDPOINT;
  const email = sessionStorage.getItem("email");
  const token = sessionStorage.getItem("number");
  const namee = sessionStorage.getItem("name");
  const numnum = sessionStorage.getItem("num");
  const avatar = sessionStorage.getItem("avatar");
  console.log("avatar", avatar);

  const [selectedAvatar, setSelectedAvatar] = useState("");
  const [oldPass, setOldPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [name, setName] = useState("");
  const [eemail, setEemail] = useState("");
  const [number, setNumber] = useState("");
  const isGoogleAuth = useSelector((state) => state.getdata.isGoogleAuth);
  console.log("profile section google auth", isGoogleAuth);
  const [firstPopup, setFirstPopup] = useState(false);
  const [secondPopup, setSecondPopup] = useState(false);

  const navigate = useNavigate();

  const handleFinalDelete = async () => {
    try {
      const res = await axios.get(`${apiUrl}delete-account`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "arraybuffer",
      });

      showToast("success", "Account deleted successfully.");
      setSecondPopup(false);

      // Navigate to Login after a short delay (optional)
      setTimeout(() => {
        navigate("/Login");
      }, 1000);
    } catch (err) {
      showToast("error", "Failed to delete account.");
      setSecondPopup(false);
    }
  };

  useEffect(() => {
    setEemail(email);
    setName(namee);
    setNumber(numnum);
  }, []);

  const handleConfirmPassChange = (e) => {
    setConfirmPass(e.target.value);
  };

  const handleNewPassChange = (e) => {
    setNewPass(e.target.value);
  };

  const handleOldPassChange = (e) => {
    setOldPass(e.target.value);
  };

  const [uploadedAvatar, setUploadedAvatar] = useState(null); // For preview

  const handleAvatarUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onloadend = () => {
      setUploadedAvatar(reader.result); // Show preview
      setSelectedAvatar(reader.result); // Set for upload
      setActiveIndex(null); // Deselect default
    };

    reader.readAsDataURL(file);
  };

  const handleDeleteUploadedAvatar = () => {
    setUploadedAvatar(null); // Remove preview
    setSelectedAvatar(""); // Clear avatar
  };

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  // Prefill first & last name when component loads
  useEffect(() => {
    const storedName = sessionStorage.getItem("name") || "";
    const nameParts = storedName.split(" "); // Split full name

    setFirstName(nameParts[0] || ""); // Set first name
    setLastName(nameParts.slice(1).join(" ") || ""); // Join remaining parts as last name
  }, []);

  const handleChangeFirstName = (e) => {
    setFirstName(e.target.value);
  };

  const handleChangeLastName = (e) => {
    setLastName(e.target.value);
  };

  const handleChangeEmail = (e) => {
    setEemail(e.target.value);
  };

  const handleChangeNumber = (e) => {
    setNumber(e.target.value);
  };

  const handleChangeInfo = async () => {
    try {
      const fullName = `${firstName} ${lastName}`.trim();
      const avatarToPass = selectedAvatar ? selectedAvatar : avatar;

      const res = await axios.post(
        `${apiUrl}edit-user`,
        {
          email: eemail,
          name: fullName,
          contact: number,
          userAvatar: avatarToPass,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      showToast("success", "Data is updated!");

      // 👇 Update state and sessionStorage
      setName(fullName);
      setSelectedAvatar(avatarToPass);
      sessionStorage.setItem("email", eemail);
      sessionStorage.setItem("name", fullName);
      sessionStorage.setItem("num", number);
      sessionStorage.setItem("avatar", avatarToPass);

      handleCancel();
    } catch (error) {
      console.error("API Error:", error.response.data.message); // <-- Debug output in console
      showToast("error", error.response.data.message);
    }
  };

  const handlePassWordChange = async () => {
    const res = await axios.post(
      `${apiUrl}change-password`,
      {
        email: email,
        oldPassword: oldPass,
        newPassword: newPass,
        confirmNewPassword: confirmPass,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    showToast("success", "Password is changed!");
    console.log("res", res);
    handleCancel();
  };

  const handleReset = () => {
    setConfirmPass("");
    setNewPass("");
    setOldPass("");
  };

  const toast = useToast();

  const showToast = (status, message) => {
    toast({
      title: `${status.charAt(0).toUpperCase() + status.slice(1)}`,
      description: message,
      status: status, // Set this to 'error' for a red-colored pop-up
      duration: 3000,
      isClosable: true,
    });
  };

  const [rootSize, setRootSize] = useState("");

  const [selectedMonth, setSelectedMonth] = useState("06");

  // MODAL
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false); // This will close the modal
  };
  // END MODAL

  // PASSWORD SHOW HIDE

  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [showPassword3, setShowPassword3] = useState(false);

  const togglePasswordVisibility1 = () => setShowPassword1(!showPassword1);
  const togglePasswordVisibility2 = () => setShowPassword2(!showPassword2);
  const togglePasswordVisibility3 = () => setShowPassword3(!showPassword3);

  // AVATAR ACTIVE
  const [activeIndex, setActiveIndex] = useState(null);

  const handleButtonClick = (index) => {
    setActiveIndex(index); // Click par active button ka index update hota hai
  };
  const [avatarBox, setavatarBox] = useState({});
  const getAllAvatars = async () => {
    try {
      const response = await axios.get(`${apiUrl}get-avatar-list`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      console.log(response.data.avatarList);
      setavatarBox(response.data.avatarList);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    console.log("avatar box is", avatarBox);
  }, [avatarBox]); // This effect runs whenever avatarBox changes.

  const [remainingStorage, setRemainingStorage] = useState("");
  const parseSizeToBytes = (sizeStr) => {
    if (!sizeStr || typeof sizeStr !== "string") return 0;

    const units = {
      Bytes: 1,
      KB: 1024,
      MB: 1024 ** 2,
      GB: 1024 ** 3,
      TB: 1024 ** 4,
    };

    const match = sizeStr.match(/([\d.]+)\s*(Bytes|KB|MB|GB|TB)/i);
    if (!match) return 0;

    const value = parseFloat(match[1]);
    const unit = match[2];

    return value * (units[unit] || 1);
  };

  const getRootFolderSize = async () => {
    try {
      const res = await axios.get(`${apiUrl}get-folder-size`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const sizeInBytes = parseSizeToBytes(res.data.totalSize);
      setRootSize(sizeInBytes);

      const totalBytes = 20 * 1024 * 1024 * 1024; // 20 GB
      const usedGB = sizeInBytes / 1024 ** 3;
      const remainingGB = (totalBytes - sizeInBytes) / 1024 ** 3;

      setRemainingStorage(remainingGB);
      setUsedStorage(usedGB);

      console.log("Used:", usedGB.toFixed(2), "GB");
      console.log("Remaining:", remainingGB.toFixed(2), "GB");
    } catch (error) {
      console.error(`There's error at ${error}`);
    }
  };

  useEffect(() => {
    getRootFolderSize();
    getAllAvatars();
  }, []);
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // ← loading state

  const getRecentFiles = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(`${apiUrl}get-recent-files`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      setFiles(res.data);
      console.log("Recent files are", res.data);
    } catch (error) {
      console.error(`There's error at ${error}`);
    } finally {
      setIsLoading(false); // ← done loading
    }
  };

  useEffect(() => {
    getRecentFiles();
  }, []);

  const [errorMessage2, setErrorMessage2] = useState("");
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showImage, setShowImage] = useState(false);
  const [videoSrc, setVideoSrc] = useState("");
  const [imageSrc, setImageSrc] = useState("");
  const [pdfSrc, setPdfSrc] = useState("");
  const [audioSrc, setAudioSrc] = useState("");
  const [isProgressVisible, setIsProgressVisible] = useState(false);
  const [modalFile, setModalFile] = useState("");

  //Image getting function
  const getImageInfo = async (filename) => {
    try {
      const res = await axios.get(`${apiUrl}getFile`, {
        params: {
          filePath: filename,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "arraybuffer",
      });
      setIsProgressVisible(false);
      console.log("Image is clicked");
      const base64Image = arrayBufferToBase64(res.data);
      const fileType = res.headers["content-type"];
      setImageSrc(`data:${fileType};base64,${base64Image}`);
    } catch (error) {
      console.error(error);
    }
  };
  //Audio getting function
  const getAudioInfo = async (filename) => {
    try {
      const res = await axios.get(`${apiUrl}getFile`, {
        params: {
          filePath: filename,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "arraybuffer",
      });
      setIsProgressVisible(false);
      const fileType = res.headers["content-type"];
      const blob = new Blob([res.data], { type: fileType });
      const url = window.URL.createObjectURL(blob);
      setAudioSrc(url);
    } catch (error) {
      console.error(error);
    }
  };

  //Pdf getting function
  const getPdfInfo = async (filename) => {
    try {
      const res = await axios.get(`${apiUrl}getFile`, {
        params: {
          filePath: filename,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "arraybuffer",
      });
      setIsProgressVisible(false);
      const fileType = res.headers["content-type"];
      const blob = new Blob([res.data], { type: fileType });
      const url = window.URL.createObjectURL(blob);
      setPdfSrc(url);
    } catch (error) {
      console.error(error);
    }
  };
  function arrayBufferToBase64(buffer) {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }
  const fileTypeExtractor = (file) => {
    const partBeforeSlash = file.split("/")[0];
    return partBeforeSlash;
  };

  useEffect(() => {
    return () => {
      if (audioSrc) {
        URL.revokeObjectURL(audioSrc);
      }
    };
  }, [audioSrc]);

  const zoomIn = () => setZoomLevel((prevZoom) => Math.min(prevZoom + 0.2, 3));
  const zoomOut = () => setZoomLevel((prevZoom) => Math.max(prevZoom - 0.2, 1));
  const toggleFullscreen = () => {
    const modalElement = document.getElementById("modal-container");

    if (!isFullscreen) {
      if (modalElement.requestFullscreen) {
        modalElement.requestFullscreen();
      } else if (modalElement.mozRequestFullScreen) {
        // Firefox
        modalElement.mozRequestFullScreen();
      } else if (modalElement.webkitRequestFullscreen) {
        // Chrome, Safari, and Opera
        modalElement.webkitRequestFullscreen();
      } else if (modalElement.msRequestFullscreen) {
        // IE/Edge
        modalElement.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        // Firefox
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        // Chrome, Safari, and Opera
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        // IE/Edge
        document.msExitFullscreen();
      }
    }

    setIsFullscreen((prev) => !prev);
  };

  const handleImageShow = () => setShowImage(true);
  const handleImageClose = () => {
    // console.log("Close button clicked!");

    // Exit fullscreen if currently in fullscreen mode
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }

    setIsFullscreen(false); // Reset fullscreen state
    setZoomLevel(1); // Reset zoom level to default
    setShowImage(false);
    setCurrentImageIndex(0);
    setImageSrc("");
    setVideoSrc("");
    setAudioSrc("");
    setPdfSrc("");
  };

  const handleNext = () => {
    setErrorMessage2("");
    setIsProgressVisible(true);
    setCurrentImageIndex((prevIndex) => {
      let newIndex = (prevIndex + 1) % files.length;
      let fileType = files[newIndex].fileType;

      // Loop to find the next item that is a file (has a fileType)
      while (!fileType && files.length > 0) {
        newIndex = (newIndex + 1) % files.length;
        fileType = files[newIndex].fileType;
      }

      if (
        fileType === "mp3" ||
        fileType === "MP3" ||
        fileType === "wav" ||
        fileType === "WAV" ||
        fileType === "ogg" ||
        fileType === "OGG" ||
        fileType === "aac" ||
        fileType === "AAC"
      ) {
        setImageSrc("");
        setVideoSrc("");
        setPdfSrc("");
        getAudioInfo(files[newIndex].fileName);
        setModalFile(files[newIndex].fileName);
      } else if (
        fileType === "jpeg" ||
        fileType === "jpg" ||
        fileType === "png" ||
        fileType === "gif" ||
        fileType === "hevc" ||
        fileType === "heif" ||
        fileType === "JPEG" ||
        fileType === "JPG" ||
        fileType === "PNG" ||
        fileType === "GIF" ||
        fileType === "HEVC" ||
        fileType === "HEIF" ||
        fileType === "svg" ||
        fileType === "SVG" ||
        fileType === "webp" ||
        fileType === "WEBP"
      ) {
        setVideoSrc("");
        setAudioSrc("");
        setPdfSrc("");
        getImageInfo(files[newIndex].fileName);
        console.log("mantra", files[newIndex].fileName);
        setModalFile(files[newIndex].fileName);
      } else if (
        fileType === "pdf" ||
        fileType === "PDF" ||
        fileType === "txt" ||
        fileType === "TXT"
      ) {
        setImageSrc("");
        setVideoSrc("");
        setAudioSrc("");
        getPdfInfo(files[newIndex].fileName);
        setModalFile(files[newIndex].fileName);
      } else if (
        fileType === "mkv" ||
        fileType === "mp4" ||
        fileType === "mov" ||
        fileType === "mpeg" ||
        fileType === "webm" ||
        fileType === "MOV"
      ) {
        setImageSrc("");
        setAudioSrc("");
        setPdfSrc("");
        setIsProgressVisible(false);
        setVideoSrc(files[newIndex].fileName);
        setModalFile(files[newIndex].fileName);
      } else {
        setImageSrc("");
        setAudioSrc("");
        setPdfSrc("");
        setVideoSrc("");
        setIsProgressVisible(false);
        setErrorMessage2("Unsupported file format");
        setModalFile(files[newIndex].fileName);
      }

      setZoomLevel(1);
      return newIndex;
    });
  };

  const handlePrev = () => {
    setErrorMessage2("");
    setIsProgressVisible(true);
    setCurrentImageIndex((prevIndex) => {
      let newIndex = (prevIndex - 1 + files.length) % files.length;
      let fileType = files[newIndex].fileType;

      // Loop to find the next item that is a file (has a fileType)
      while (!fileType && files.length > 0) {
        newIndex = (newIndex - 1 + files.length) % files.length;
        fileType = files[newIndex].fileType;
      }

      if (
        fileType === "mp3" ||
        fileType === "MP3" ||
        fileType === "wav" ||
        fileType === "WAV" ||
        fileType === "ogg" ||
        fileType === "OGG" ||
        fileType === "aac" ||
        fileType === "AAC"
      ) {
        setImageSrc("");
        setVideoSrc("");
        setPdfSrc("");
        getAudioInfo(files[newIndex].fileName);
        setModalFile(files[newIndex].fileName);
      } else if (
        fileType === "jpeg" ||
        fileType === "jpg" ||
        fileType === "png" ||
        fileType === "gif" ||
        fileType === "hevc" ||
        fileType === "heif" ||
        fileType === "JPEG" ||
        fileType === "JPG" ||
        fileType === "PNG" ||
        fileType === "GIF" ||
        fileType === "HEVC" ||
        fileType === "HEIF" ||
        fileType === "svg" ||
        fileType === "SVG" ||
        fileType === "webp" ||
        fileType === "WEBP"
      ) {
        setVideoSrc("");
        setAudioSrc("");
        setPdfSrc("");
        getImageInfo(files[newIndex].fileName);
        setModalFile(files[newIndex].fileName);
      } else if (
        fileType === "pdf" ||
        fileType === "PDF" ||
        fileType === "txt" ||
        fileType === "TXT"
      ) {
        setImageSrc("");
        setVideoSrc("");
        setAudioSrc("");
        getPdfInfo(files[newIndex].fileName);
        setModalFile(files[newIndex].fileName);
      } else if (
        fileType === "mkv" ||
        fileType === "mp4" ||
        fileType === "mov" ||
        fileType === "mpeg" ||
        fileType === "webm" ||
        fileType === "MOV"
      ) {
        setImageSrc("");
        setAudioSrc("");
        setPdfSrc("");
        setIsProgressVisible(false);
        setVideoSrc(files[newIndex].fileName);
        setModalFile(files[newIndex].fileName);
      } else {
        setImageSrc("");
        setAudioSrc("");
        setPdfSrc("");
        setVideoSrc("");
        setIsProgressVisible(false);
        setErrorMessage2("Unsupported file format");
        setModalFile(files[newIndex].fileName);
      }
      setZoomLevel(1);
      return newIndex;
    });
  };

  //Handle prev by arrow
  useEffect(() => {
    // Function to handle keydown events
    const handleKeyDown = (event) => {
      if (showImage && event.key === "ArrowLeft") {
        handlePrev(); // Trigger the function when the left arrow key is pressed and the modal is open
      }
    };

    // Add the event listener when the component mounts
    window.addEventListener("keydown", handleKeyDown);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [showImage]);

  useEffect(() => {
    // Function to handle keydown events
    const handleKeyDown = (event) => {
      if (showImage) {
        if (event.key === "ArrowLeft") {
          handlePrev(); // Trigger handlePrev when the left arrow key is pressed
        } else if (event.key === "ArrowRight") {
          handleNext(); // Trigger handleNext when the right arrow key is pressed
        }
      }
    };

    // Add the event listener when the component mounts
    window.addEventListener("keydown", handleKeyDown);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [showImage]);

  function getTextAfterLastSlash(text) {
    if (text.includes("/")) {
      return text.substring(text.lastIndexOf("/") + 1);
    } else {
      return text;
    }
  }

  // Assuming rootsize is in MB
  // const rootSizeInMB = parseFloat(rootsize);
  // const rootSizeInGB = rootSizeInMB / 1024;
  // const totalGB = 20;
  // const remainingGB = totalGB - rootSizeInGB;

  return (
    <>
      <ChakraProvider></ChakraProvider>
      <SideNav />
      <div className="container-fluid page-body-wrapper">
        <nav className="navbar p-0 fixed-top d-flex flex-row">
          <div className="navbar-brand-wrapper d-flex d-lg-none align-items-center justify-content-center">
            <a className="navbar-brand brand-logo-mini" href="#">
              <img src={Logo} alt="logo" />
            </a>
          </div>
          <div className="navbar-menu-wrapper flex-grow d-flex align-items-stretch">
            <ToggleNav />
            <div className="navbar-nav page_title">
              <h1>User Profile</h1>
            </div>
          </div>
        </nav>

        {/* Main Content */}
        <div className="main-panel">
          <div className="content-wrapper" style={{ padding: "15px" }}>
            <div className="row">
              <div className="col-lg-6 mt-2">
                <div className="profile_box">
                  <div className="profile_row">
                    <div className="img_profile">
                      <img src={avatar} />
                    </div>

                    <div className="profile_text">
                      <h5> {name}</h5>
                      <h6>
                        User Permission: <span>View Only</span>
                      </h6>
                      <p>
                        <span>Email:</span> {eemail}
                      </p>
                      <p>
                        <span>Mobile:</span> {number}
                      </p>
                      <div className="delete_edit_div">
                        <button
                          className="btn__edit__profile"
                          onClick={showModal}
                        >
                          Edit Profile
                        </button>
                        <button
                          onClick={() => setFirstPopup(true)}
                          className="btn__delete__profile"
                        >
                          Delete Account
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mt-2">
                <div className="profile_box">
                  <div className="profile_row">
                    <div
                      className="CircularProgress_bar"
                      style={{ textAlign: "center", paddingLeft: 30 }}
                    >
                      <Progress
                        type="circle"
                        percent={(rootSize / (20 * 1024 * 1024 * 1024)) * 100}
                        strokeWidth={25}
                        strokeColor="#F68D2B"
                        trailColor="#FFE7C6"
                        strokeLinecap="butt"
                        format={() => {
                          const percentUsed =
                            (rootSize / (20 * 1024 * 1024 * 1024)) * 100;
                          return (
                            <div>
                              <div className="percent_text">
                                {Math.round(percentUsed)}%
                              </div>
                              <div
                                style={{
                                  fontSize: "13px",
                                  color: "#BDBDBD",
                                  fontWeight: 600,
                                }}
                              >
                                Used
                              </div>
                            </div>
                          );
                        }}
                        size={180}
                      />
                    </div>

                    <div className="storage_text">
                      <div className="storage_used">
                        <h5>Storage Used</h5>
                        <h4>
                          {(rootSize ? rootSize / 1024 ** 3 : 0).toFixed(2)} GB
                          / 20 GB
                        </h4>
                      </div>

                      <div className="storage_remaining">
                        <h5>Storage Remaining</h5>
                        <h4>
                          {(20 - (rootSize ? rootSize / 1024 ** 3 : 0)).toFixed(
                            2
                          )}{" "}
                          GB / 20 GB
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="profile_row">
              <div className="profile_table_box">
                <div className="profile_table_title_row">
                  <h5>Recent Uploads</h5>
                </div>

                <div className="recent_table_box">
                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>File Name</th>
                          <th className="text-center">Date Uploaded</th>
                          <th className="text_right">File Size</th>
                          <th className="text-center">Type</th>
                        </tr>
                      </thead>

                      <tbody>
                        {isLoading ? (
                          [...Array(5)].map((_, index) => (
                            <tr key={index}>
                              <td>
                                <div className="skeleton skeleton-filename" />
                              </td>
                              <td className="text-center">
                                <div className="skeleton skeleton-text" />
                              </td>
                              <td className="text_right">
                                <div className="skeleton skeleton-text" />
                              </td>
                              <td className="text-center">
                                <div className="skeleton skeleton-pill" />
                              </td>
                            </tr>
                          ))
                        ) : files.length === 0 ? (
                          <tr>
                            <td colSpan="4" className="text-center">
                              No Recent files available.
                            </td>
                          </tr>
                        ) : (
                          files.map((file, index) => (
                            <tr key={index}>
                              <td>
                                <div className="filename_row">
                                  <span>
                                    <img src={file.icon} height={32} />
                                  </span>
                                  <span
                                    onClick={() => {
                                      setErrorMessage2("");

                                      const fname = file.fileName;
                                      const index = files.findIndex(
                                        (file) => file.fileName === fname
                                      );
                                      if (index !== -1) {
                                        setCurrentImageIndex(index);
                                      }

                                      const openPreview = () => {
                                        setModalFile(file.fileName);
                                        handleImageShow();
                                      };

                                      const isVideo = [
                                        "mkv",
                                        "mp4",
                                        "mov",
                                        "mpeg",
                                        "webm",
                                        "MOV",
                                      ];
                                      const isImage = [
                                        "jpeg",
                                        "jpg",
                                        "png",
                                        "gif",
                                        "hevc",
                                        "heif",
                                        "svg",
                                        "webp",
                                        "JPEG",
                                        "JPG",
                                        "PNG",
                                        "GIF",
                                        "HEVC",
                                        "HEIF",
                                        "SVG",
                                        "WEBP",
                                      ];
                                      const isAudio = [
                                        "mp3",
                                        "wav",
                                        "ogg",
                                        "aac",
                                        "MP3",
                                        "WAV",
                                        "OGG",
                                        "AAC",
                                      ];
                                      const isDoc = [
                                        "pdf",
                                        "PDF",
                                        "txt",
                                        "TXT",
                                      ];

                                      if (isVideo.includes(file.fileType)) {
                                        openPreview();
                                        setVideoSrc(file.fileName);
                                      } else if (
                                        isImage.includes(file.fileType)
                                      ) {
                                        openPreview();
                                        getImageInfo(file.fileName);
                                      } else if (
                                        isAudio.includes(file.fileType)
                                      ) {
                                        openPreview();
                                        getAudioInfo(file.fileName);
                                      } else if (
                                        isDoc.includes(file.fileType)
                                      ) {
                                        openPreview();
                                        getPdfInfo(file.fileName);
                                      } else {
                                        if (file.isFolder === true) {
                                          console.log("It's a folder.");
                                        } else {
                                          openPreview();
                                          setErrorMessage2(
                                            "File format not supported!"
                                          );
                                        }
                                      }
                                    }}
                                    className="filename_link"
                                  >
                                    {getTextAfterLastSlash(file.fileName)}
                                  </span>
                                </div>
                              </td>
                              <td className="text-center">
                                {file.uploadDateTime}
                              </td>
                              <td className="text_right">{file.fileSize}</td>
                              <td className="text-center">
                                <div className="type_pp">{file.ACL}</div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="profile_stolity_app">
                <h5>
                  Get the Stolity <br />
                  App today!
                </h5>
                <br />
                Available on both the App <br />
                Store & Play Store
                <div className="profile_stolity_app_bottom">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.stolity.infomanav.com"
                    className="btn_app_download"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Download
                  </a>

                  <img src={ImgStolityApp} className="img_responsive" />
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
        {/* main-panel ends */}
      </div>

      {/* First Confirmation Modal */}
      {/* Delete Account Button */}

      {/* First Confirmation Modal */}
      {firstPopup && (
        <div className="rename_popup_wrapper">
          <div className="rename_modal">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "15px",
              }}
            >
              <img src={DeletePopup} alt="Delete Icon" />
            </div>
            <h2 className="rename_title2">
              Are you sure you want to delete your account?
            </h2>
            <p className="rename_subtext">This action cannot be undone.</p>
            <div className="rename_buttons">
              <button
                className="rename_btn cancel"
                onClick={() => setFirstPopup(false)}
              >
                No
              </button>
              <button
                className="rename_btn ok"
                style={{ backgroundColor: "#FF0000" }}
                onClick={() => {
                  setFirstPopup(false);
                  setSecondPopup(true);
                }}
              >
                Yes, Continue
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Second (Final) Confirmation Modal */}
      {secondPopup && (
        <div className="rename_popup_wrapper">
          <div
            className="rename_modal"
            style={{ width: "420px", padding: "32px 20px" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "15px",
              }}
            >
              <img src={DeletePopup} alt="Delete Icon" />
            </div>
            <h2 className="rename_title2">Your data will be lost forever.</h2>
            <p className="rename_subtext">This action cannot be reversed.</p>
            <div className="rename_buttons">
              <button
                className="rename_btn cancel"
                onClick={() => setSecondPopup(false)}
              >
                No
              </button>
              <button
                className="rename_btn ok"
                style={{ backgroundColor: "#FF0000" }}
                onClick={handleFinalDelete}
              >
                Delete Permanently
              </button>
            </div>
          </div>
        </div>
      )}

      <Modal
        title=""
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        width={600}
      >
        <div className="edit-profile-modal">
          <h4 className="text-center">Edit Profile</h4>

          {/* AVATAR SELECTION */}
          <div className="avatar-section">
            <h6 className="text-center">AVATAR SELECTION</h6>
            <div className="avatar-list">
              {[Avatar1, Avatar2, Avatar3, Avatar4].map((avatar, index) => (
                <button
                  key={index}
                  className={`avatar-btn ${
                    activeIndex === index ? "active" : ""
                  }`}
                  onClick={() => {
                    setSelectedAvatar(avatarBox[index + 1].url);
                    setActiveIndex(index);
                    setUploadedAvatar(null); // Clear uploaded preview
                  }}
                >
                  <img src={avatar} alt={`Avatar ${index + 1}`} />
                </button>
              ))}

              {/* Show uploaded avatar preview */}
              {uploadedAvatar ? (
                <div className="avatar-btn custom-avatar-preview active">
                  <img src={uploadedAvatar} alt="Uploaded Avatar" />
                  <span
                    className="btn-delete-avatar"
                    onClick={handleDeleteUploadedAvatar}
                  >
                    <i className="icon-delete2" />
                  </span>
                </div>
              ) : (
                <>
                  <input
                    type="file"
                    id="avatarUploadInput"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={(e) => handleAvatarUpload(e)}
                  />
                  <button
                    className="avatar-btn add-avatar"
                    onClick={() =>
                      document.getElementById("avatarUploadInput").click()
                    }
                  >
                    <span>+</span>
                  </button>
                </>
              )}
            </div>
          </div>

          {/* PERSONAL INFORMATION */}
          <div className="profile-section">
            <h5>PERSONAL INFORMATION</h5>
            <div className="row">
              <div className="col-6">
                <div className="form-group">
                  <label className="form-label">First Name</label>
                  <input
                    value={firstName}
                    onChange={handleChangeFirstName}
                    type="text"
                    className="form-control"
                    placeholder="Enter First Name"
                    required
                  />
                </div>
              </div>

              <div className="col-6">
                <div className="form-group">
                  <label className="form-label">Last Name</label>
                  <input
                    value={lastName}
                    onChange={handleChangeLastName}
                    type="text"
                    className="form-control"
                    placeholder="Enter Last Name"
                    required
                  />
                </div>
              </div>

              <div className="col-6">
                <div className="form-group">
                  <label className="form-label">Mobile</label>
                  <input
                    value={number}
                    onChange={handleChangeNumber}
                    type="text"
                    className="form-control"
                    placeholder="Enter Mobile No."
                  />
                </div>
              </div>

              <div className="col-6">
                <div className="form-group">
                  <label className="form-label">Email</label>
                  <input
                    value={eemail}
                    onChange={handleChangeEmail}
                    type="email"
                    className="form-control"
                    placeholder="Enter Email ID"
                  />
                </div>
              </div>
            </div>
          </div>

          {!isGoogleAuth && (
            <>
              {/* PASSWORD SECTION */}
              <div className="profile-section">
                <h5>PASSWORD</h5>
                <div className="row">
                  <div className="col-4">
                    <div className="form-group">
                      <label className="form-label">Current Password</label>
                      <div className="password-field">
                        <input
                          type={showPassword1 ? "text" : "password"}
                          value={oldPass}
                          onChange={handleOldPassChange}
                          className="form-control"
                          placeholder="Current Password"
                        />
                        <button
                          className="password-toggle"
                          onClick={togglePasswordVisibility1}
                        >
                          {showPassword1 ? <PasswordShow /> : <PasswordHide />}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="col-4">
                    <div className="form-group">
                      <label className="form-label">New Password</label>
                      <div className="password-field">
                        <input
                          type={showPassword2 ? "text" : "password"}
                          value={newPass}
                          onChange={handleNewPassChange}
                          className="form-control"
                          placeholder="New Password"
                        />
                        <button
                          className="password-toggle"
                          onClick={togglePasswordVisibility2}
                        >
                          {showPassword2 ? <PasswordShow /> : <PasswordHide />}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="col-4">
                    <div className="form-group">
                      <label className="form-label">Confirm Password</label>
                      <div className="password-field">
                        <input
                          type={showPassword3 ? "text" : "password"}
                          value={confirmPass}
                          onChange={handleConfirmPassChange}
                          className="form-control"
                          placeholder="Confirm Password"
                        />
                        <button
                          className="password-toggle"
                          onClick={togglePasswordVisibility3}
                        >
                          {showPassword3 ? <PasswordShow /> : <PasswordHide />}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* BUTTONS */}
          <div className="button-group">
            <button className="btn-cancel" onClick={handleCancel}>
              Cancel
            </button>
            <button
              className="btn-save"
              onClick={() => {
                // If any password field is filled, call both
                if (oldPass || newPass || confirmPass) {
                  handlePassWordChange(); // Will only be called if there's password input
                }

                // Always call profile info update
                handleChangeInfo();
              }}
            >
              Save Changes
            </button>
          </div>
        </div>
      </Modal>

      {/*All files Shower */}
      <RsuiteModal
        open={showImage}
        onClose={handleImageClose}
        className="file_upload_modal_style"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          padding: "0",
          borderRadius: "15px",
          margin: "auto",
        }}
      >
        <div
          id="modal-container"
          style={{
            width: isFullscreen ? "100vw" : "100%",
            maxWidth: isFullscreen ? "none" : "720px",
            backgroundColor: "white",
            borderRadius: "8px",
            overflow: "hidden",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            height: isFullscreen ? "100vh" : "90vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Header */}

          <button
            onClick={handleImageClose}
            style={{
              position: "absolute",
              top: "15px",
              right: "15px",
              background: "none",
              border: "none",
              fontSize: "30px",
              cursor: "pointer",
              color: "#888",
              zIndex: 1000,
            }}
          >
            ×
          </button>

          {isProgressVisible && (
            <span className="loader"></span> // Added loader at the top
          )}
          <div
            style={{
              flex: 1,
              padding: "0",
              position: "relative",
              // backgroundColor: "#f9f9f9",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "auto", // Make content scrollable if it exceeds the height
            }}
          >
            <button
              onClick={handlePrev}
              style={{
                position: "fixed",
                left: "20px",
                background: "none",
                border: "none",
                fontSize: "30px",
                cursor: "pointer",
                zIndex: 10,
                backgroundColor: "white",
                borderRadius: "25px",
                padding: "0 15px",
              }}
            >
              ❮
            </button>


{isProgressVisible ? (
              // Show loader *inside* the content area
              <div
                style={{
                  height: "100px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img src={loaderGif} alt="" style={{ height: "50%" }} />
              </div>
            ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                // backgroundColor: isFullscreen
                //   ? "rgba(0, 0, 0, 0.8)"
                //   : "rgba(0, 0, 0, 0.5)",
                padding: isFullscreen ? "0" : "20px",
                width: isFullscreen ? "100%" : "80%",
                height: isFullscreen ? "100%" : "90%",
                transform: `scale(${zoomLevel})`,
                transition: "transform 0.2s ease-in-out",
              }}
            >
              {videoSrc ? (
                <ReactPlayer
                  url={`${apiUrl}getFileDefault?token=${token}&filePath=${videoSrc}`}
                  controls
                  playing={true}
                  width="100%"
                  height="100%"
                />
              ) : pdfSrc ? (
                <iframe
                  src={pdfSrc}
                  border="0"
                  width="100%"
                  style={{
                    height: isFullscreen ? "100%" : "220px",
                    border: "none",
                    backgroundColor: "white",
                  }}
                />
              ) : imageSrc ? (
                <img
                    src={imageSrc}
                    alt="Image format not supported"
                    style={{
                      width: "auto",
                      maxWidth: isFullscreen ? "90vw" : "100%",
                      maxHeight: isFullscreen ? "90vh" : "80vh",
                      objectFit: "contain",
                      borderRadius: "6px",
                      transform: `scale(${zoomLevel})`,
                      transition: "transform 0.2s ease-in-out",
                    }}
                  />
              ) : audioSrc ? (
                <div className="audio_player_modal">
                  <audio
                    controls
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      position: "relative",
                    }}
                  >
                    <source src={audioSrc} type="audio/ogg" />
                    <source src={audioSrc} type="audio/mpeg" />
                    <source src={audioSrc} type="audio/wav" />
                    <source src={audioSrc} type="audio/mp3" />
                    Your browser does not support the audio element.
                  </audio>
                </div>
              ) : errorMessage2 ? (
                <p>{errorMessage2}</p>
              ) : (
                <p></p>
              )}
            </div>
 )}
            <button
              onClick={handleNext}
              style={{
                position: "fixed",
                right: "20px",
                background: "none",
                border: "none",
                fontSize: "30px",
                cursor: "pointer",
                zIndex: 10,
                backgroundColor: "white",
                borderRadius: "25px",
                padding: "0 15px",
              }}
            >
              ❯
            </button>
          </div>

          <div
            style={{
              padding: "15px 20px",
              borderTop: "1px solid #eee",
              backgroundColor: "white",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#f5f5f5",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                <Button onClick={zoomIn}>
                  <img
                    src={zoomin}
                    alt="Zoom In"
                    style={{ width: "19px", height: "19px" }}
                  />
                </Button>
                Zoom
                <Button onClick={zoomOut}>
                  <img
                    src={zoomout}
                    alt="Zoom Out"
                    style={{ width: "19px", height: "19px" }}
                  />
                </Button>
              </div>

              <button
                onClick={toggleFullscreen}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "8px 12px",
                  backgroundColor: "#f5f5f5",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                <img
                  src={fullscreeen}
                  alt="Zoom Out"
                  style={{
                    width: "15px",
                    height: "15px",
                    marginRight: "6px",
                  }}
                />
                {isFullscreen ? "Exit Fullscreen" : "Fullscreen"}
              </button>

              {/* <button
                onClick={() => deleteFromModal(modalFile)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "8px 12px",
                  backgroundColor: "#f5f5f5",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                <img
                  src={deleteIcon3}
                  alt="Zoom Out"
                  style={{
                    width: "15px",
                    height: "15px",
                    marginRight: "6px",
                  }}
                />
                Remove
              </button> */}
            </div>
          </div>
        </div>
      </RsuiteModal>
    </>
  );
};

export default UserProfile;
